import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';
import { TaskPointsBadge } from '.';

const SequencingAnswer = ({ answers, maxScore, options, score }) => {
  const { messages, theme } = useReduxState();

  const isCorrect = answers.map(
    (answer, i) => options[i]?.id && answer === options[i].id
  );
  const answersLong = answers
    .map((answer) => options.find((option) => answer === option.id))
    .filter((option) => Boolean(option));

  return (
    <div className="answer">
      <div className="options">
        {answersLong.map((answer, i) => (
          <div className="option" key={answer.id}>
            <div className="option-text">
              <div
                className="option-text-content"
                dangerouslySetInnerHTML={{ __html: answer.text }}
              />
            </div>
            <div className="option-correct">
              {isCorrect[i] ? (
                <div
                  aria-label={messages.readerMultipleChoiceCorrectOption}
                  data-tooltip={messages.readerMultipleChoiceCorrectOption}
                >
                  <Icon
                    icon="check"
                    fixedWidth={true}
                    style={{ color: theme.successStandaloneColor }}
                  />
                </div>
              ) : (
                <div
                  aria-label={messages.readerMultipleChoiceIncorrectOption}
                  data-tooltip={messages.readerMultipleChoiceIncorrectOption}
                >
                  <Icon
                    icon="times"
                    fixedWidth={true}
                    style={{ color: theme.dangerColor }}
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <TaskPointsBadge maxPoints={maxScore} points={score} />

      <style jsx>{`
        .options {
          counter-reset: sequencing-option;
        }
        .option {
          background-color: white;
          border-radius: 4px;
          color: ${theme.textColorLight};
          display: flex;
          font-size: 1.4rem;
          padding: 8px 10px;
        }
        .option:not(:first-child) {
          margin-top: 10px;
        }
        .option-text {
          display: flex;
          flex-grow: 1;
          min-width: 0;
        }
        .option-text::before {
          counter-increment: sequencing-option;
          content: counter(sequencing-option) ' )';
          display: inline-block;
          margin-right: 3px;
        }
        .option-text-content {
          word-break: break-word;
        }
        .option-text-content :global(p) {
          margin: 8px 0 0;
        }
        .option-text-content :global(p:first-child) {
          margin-top: 0;
        }
        .option-correct {
          flex-grow: 0;
          flex-shrink: 0;
          font-size: 1.2rem;
          margin-left: 10px;
        }
      `}</style>
    </div>
  );
};

export default SequencingAnswer;
